import { useEffect } from "react";
import { MdClose } from "react-icons/md";

export default function ModalExtraSmall({ children, handleChange, ...props }) {
  useEffect(() => {
    if (props.isOpen === true) {
      // console.log("addnoscroll");
      // document.querySelector("body").classList.add("noscroll");
    } else {
      // console.log("removenoscroll");
      closeModal();
    }
  }, [props.isOpen]);

  const closeModal = () => {
    // document.querySelector("body").classList.remove("noscroll");
    handleChange(false);
  };

  // bouton retour
  // addEventListener("popstate", (event) => {
  //   if (props.isOpen === true) {
  //     closeModal();
  //   }
  // });

  // bouton echap
  // addEventListener("keydown", (event) => {
  //   if (event.key === "Escape" && props.isOpen === true) {
  //     closeModal();
  //   }
  // });

  return props.isOpen ? (
    <>
      <div
        className="modal modal-open"
        onClick={(e) => {
          e.stopPropagation();
          closeModal();
        }}
      >
        <div
          className="w-3/4 sm:w-96 max-h-3/4 mx-auto my-auto px-4 py-5 rounded bg-base-100 border border-base-200"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {children}
          <div className="border-t border-base-content/30 my-2"></div>
          <button
            className="flex w-full items-center text-base-content leading-10 text-base hover:text-secondary cursor-pointer"
            onClick={(e) => {
              closeModal();
            }}
          >
            <MdClose className="w-4 h-4 mr-2" />
            Annuler
          </button>
        </div>
      </div>
    </>
  ) : null;
}
